import React from "react";
import { useParams } from "react-router-dom";
import { usePermissionGuardRedirect } from "../../../../../hooks/usePermissionGuard";
import { GetExamListAuditFilters, getExamListAuditTrails } from "../../../../../services/ExternalExamServices";
import AuditTrailsTable from "../../../../common/AuditTrailsTable";

function DetailsAuditTrail() {
  const { id, type, subType, subTab, subId } = useParams();
  let param = {exam_id : id};
  let reg_params = {action_id:id, exam_id:subId};  
  const columnsToShow = ["Action Type", "Resource Type", "Resource Name"];

  usePermissionGuardRedirect(['eerleview']);
  
  return (
    <AuditTrailsTable 
      apiFunction={getExamListAuditTrails}
      filterArrApi={GetExamListAuditFilters}
      columnsToShow={columnsToShow}
      exportFileName={"Exam_Audit_Trail"}
      isResourceNameShown={true}
      apiParams={(type=="open" && subTab !== "registration") ? param : (subTab === "registration" && subType === "audit-trail") ? reg_params :{action_id: id}}
      actionId={id}
      isShowingResourceTypeFilter
    />
  );
}

export default DetailsAuditTrail;
